import React from 'react'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons"


function Loader() {
    return (          
        <div className="is-flex is-justify-content-center">
        <FontAwesomeIcon
            size={`8x`}
            className={`fa fa-spin`}
            icon={faSpinner}
        /> 
        </div>
    )
}

export default Loader;